/**
 * Created by Administrador on 13/09/2017.
 */
(function(){
    'use strict';

    angular
        .module('completeAir')
        .factory('departureService', departureService);

    departureService.$inject = ['$http', 'CONFIG', 'messageService'];

    function departureService($http, CONFIG, messageService){
        var urlBase = CONFIG.API_URL + '/' + CONFIG.API_PNR + '/' + CONFIG.API + '/pnr';
        var urlBaseC = CONFIG.API_URL + '/' + CONFIG.API_PNR + '/' + CONFIG.API;
        var service = {
            getPNRs: getPNRs,
            getCheckInPNRs: getCheckInPNRs,
            getPNR: getPNR,
            getPNRById: getPNRById,
            updateChangeFlightPnr: updateChangeFlightPnr,
            updateTransferLuggage: updateTransferLuggage,
            findChannel: findChannel,
            findTemplate: findTemplate,
            sendDataReportPostConfig: sendDataReportPostConfig,
        }

        return service;

        function getPNRs(segmentFlightId,page,size){
            return $http.get(urlBase +"/search/pnr/" + segmentFlightId + "/passengers?transfer=true&page=" + page + '&size=' + size)
                .then(function(response){
                    return (response.data._embedded) ? response.data._embedded.pnrs : [];
                })
                .catch(function(){
                    messageService.findAllError('');
                });
        }

        function getCheckInPNRs(segmentFlightId,page,size){
            return $http.get(urlBase +"/search/pnr/" + segmentFlightId + "/passengers?checkIn=true&page=" + page + '&size=' + size)
                .then(function(response){
                    return (response.data._embedded) ? response.data._embedded.pnrs : [];
                })
                .catch(function(){
                    messageService.findAllError('');
                });
        }

        function getPNR(pnrCode){
            return $http.get(urlBase +"?pnrCode=" + pnrCode)
                .then(function(response){
                    return (response.data) ? response.data : {};
                })
                .catch(function(){
                    messageService.findAllError('');
                });
        }

        function getPNRById(pnrId){
            return $http.get(urlBase +"/PNR/" + pnrId)
                .then(function(response){
                    return (response.data) ? response.data : {};
                })
                .catch(function(){
                    messageService.findAllError('');
                });
        }

        function updateChangeFlightPnr(operationSale, userLogin,status){
            return $http.put(urlBase + "/flight?user_login=" + userLogin, operationSale)
                .then(function(response){
                    if(status!=='CHECKED'){
                        messageService.registerUpdate('')
                    }
                    return "ok";
                })
                .catch(function(error){
                    messageService.findAllError('');
                    return "error"
                });
        }

        function updateTransferLuggage(pnrCode, oldSegmentFlightId, newSegmentFlightId, userLogin){
            return $http.put(urlBase + "/transfer/luggage/"+pnrCode+"?oldSegmentFlightId="+oldSegmentFlightId+"&newSegmentFlightId="+newSegmentFlightId+"&user_login=" + userLogin)
                .then(function(response){
                    messageService.registerUpdate('')
                    return response;
                })
                .catch(function(error){
                    messageService.findAllError('');
                });
        }

        function findChannel(login) {
            return $http.get(urlBaseC + '/message-feign/channels?user_login=' + login)
                .then(function(response){
                    return response;
                }, function(){
                    messageService.findError('');
                });
        }

        function findTemplate(channel, application, login) {
            return $http.get(urlBaseC + '/message-feign/template/'+channel+'/'+application+'?user_login=' + login)
                .then(function(response){
                    return response;
                }, function(){
                    messageService.findError('');
                });
        }

        function sendDataReportPostConfig(sendType, dto) {
            return $http.post(urlBaseC + '/report-feign/send-message?sendType=' + sendType, dto)
                .then(function(response) {
                    return response;
                })
                .catch(function(){
                    messageService.findError('');
                });
        }
    };
})();
